import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackGetButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'Click',
    label: 'rosreestr_data',
  });
};

export const trackCloseButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'Cancel',
    label: 'rosreestr_data',
  });
};
